import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines } from "@/components/motion/Reveal";
import { IMAGES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function CTA() {
  return (
    <section
      id="contact"
      className="relative py-16 lg:py-24 bg-white"
      data-testid="cta-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="relative overflow-hidden rounded-[2rem] bg-[#1F2937] px-8 py-16 sm:px-14 lg:px-20 lg:py-24"
        >
          <div className="absolute inset-0 grid-lines opacity-[0.06]" />
          <img
            src={IMAGES.orb}
            alt=""
            className="pointer-events-none absolute -right-16 -top-16 w-72 lg:w-96 opacity-40 mix-blend-screen select-none"
          />
          <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-white/[0.04] blur-3xl" />

          <div className="relative max-w-3xl">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-white/50">
              Get started
            </p>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.98] text-white">
              <MaskedLines lines={["Ready to Transform Your"]} />
              <span className="block overflow-hidden">
                <motion.span
                  className="block text-white/60"
                  initial={{ y: "110%" }}
                  whileInView={{ y: "0%" }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.9, ease: EASE, delay: 0.12 }}
                >
                  Customer Experience?
                </motion.span>
              </span>
            </h2>
            <p className="mt-6 max-w-xl text-base lg:text-lg leading-relaxed text-white/60">
              Start building smarter customer interactions with AI-powered
              enterprise solutions trusted by global organizations.
            </p>
            <motion.a
              href="#top"
              data-testid="cta-schedule-demo"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="group mt-10 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-[#1F2937] shadow-xl"
            >
              Schedule a Demo
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
